import {update} from './update.js';
import {getGlobalState, setGlobalState} from './state.js';

import {
  EVENT_UPDATED_TOOL,
  EVENT_UPDATED_GRADE,
  EVENT_UPDATED_PERSON,
  EVENT_UPDATED_SCHOOL,
  EVENT_UPDATED_JOB_TITLE,
  EVENT_UPDATED_DEPARTMENT
} from './consts';

function updateCommon(event, value) {
  const state = getGlobalState();
  setGlobalState(update(state, event, value));
}

export function updateJobTitle(e) {
  const jobTitle = e.target.value;
  updateCommon(EVENT_UPDATED_JOB_TITLE, jobTitle);
}

export function updateSchool(schoolId) {
  updateCommon(EVENT_UPDATED_SCHOOL, schoolId);
}

export function updatePerson(personId) {
  updateCommon(EVENT_UPDATED_PERSON, personId);
}

export function updateTool(toolId) {
  updateCommon(EVENT_UPDATED_TOOL, toolId);
}

export function updateDepartment(departmentId) {
  updateCommon(EVENT_UPDATED_DEPARTMENT, departmentId);
}

export function updateGrade(gradeId) {
  updateCommon(EVENT_UPDATED_GRADE, gradeId);
}
